import React, { FC } from 'react';
import { Flex } from 'roo-ui/components';
import { LinkList } from '../../../lib/types';
import { StyledRegionLinks } from '../primitives';

export const Links: FC<LinkList> = ({
  title,
  linkList = [],
  itemRenderer,
  onInteraction = () => {},
  queryString,
}) => {
  const onClickHandler = (trackingName?: string) =>
    onInteraction({
      type: 'Footer Navigation',
      value: `${trackingName} Selected`,
    });

  const parsedLinks = linkList.map((linkProps) => {
    const { href, to, usesQueryParams, trackingName } = linkProps;
    const allQueryParams =
      usesQueryParams && queryString ? `?${queryString}` : '';
    return {
      ...linkProps,
      name: String(linkProps.children),
      href: href ? `${href}${allQueryParams}` : '',
      to: to ? `${to}${allQueryParams}` : '',
      onClick: () => onClickHandler(trackingName),
      color: 'white',
      'data-testid': linkProps['data-testid'],
    };
  });

  return (
    <>
      {itemRenderer && (
        <Flex mb={8} flexDirection="column" width={['50%', '25%']}>
          <StyledRegionLinks
            title={title}
            color="white"
            fontSize="lg"
            mb={0}
            regions={parsedLinks}
          />
          {itemRenderer()}
        </Flex>
      )}
      {!itemRenderer && (
        <StyledRegionLinks
          title={title}
          color="white"
          fontSize="lg"
          regions={parsedLinks}
        />
      )}
    </>
  );
};
